import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const Card = styled.div`
  background: white;
  border-radius: 14px;
  padding: 24px;
  box-shadow: 0 1px 3px var(--vo-escuro-8);
`;

const CardTitle = styled.p`
  font-family: 'Rubik', sans-serif;
  font-size: 15px;
  font-weight: 600;
  color: var(--vo-ink);
  margin: 0 0 16px;
`;

const StatsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 12px;
`;

const StatBox = styled.div`
  text-align: center;
  padding: 16px 12px;
  background: ${({ $bg }) => $bg};
  border-radius: 10px;
`;

const StatNum = styled.p`
  font-family: 'Rubik', sans-serif;
  font-size: 28px;
  font-weight: 700;
  color: ${({ $color }) => $color};
  margin: 0 0 4px;
`;

const StatLabel = styled.p`
  font-family: 'Maven Pro', sans-serif;
  font-size: 11px;
  color: var(--vo-slate);
  margin: 0;
  text-transform: uppercase;
  letter-spacing: .06em;
`;

export const CardTotalVisitors = ({ totalVisitors, optIn, optOut }) => {
  const { t } = useTranslation(['cookies']);
  return (
    <Card>
      <CardTitle>{t('cookies:show.totalVisitors.label')}</CardTitle>
      <StatsGrid>
        <StatBox $bg="var(--vo-mist)">
          <StatNum $color="var(--vo-celeste)">{totalVisitors ?? 0}</StatNum>
          <StatLabel>{t('cookies:show.totalVisitors.unique')}</StatLabel>
        </StatBox>
        <StatBox $bg="var(--vo-success-10)">
          <StatNum $color="var(--vo-success)">{optIn ?? 0}</StatNum>
          <StatLabel>{t('cookies:show.totalVisitors.optIn')}</StatLabel>
        </StatBox>
        <StatBox $bg="var(--vo-danger-10)">
          <StatNum $color="var(--vo-danger)">{optOut ?? 0}</StatNum>
          <StatLabel>{t('cookies:show.totalVisitors.optOut')}</StatLabel>
        </StatBox>
      </StatsGrid>
    </Card>
  );
};
